import { getSupabase } from "./client";

/** Auth eligibility needs only this lookup, not the cloud-project APIs and
 * their document migration registry. A failed lookup remains unknown. */
export async function isCurrentUserAdmin(): Promise<boolean | null> {
  const sb = getSupabase();
  const { data: user, error: userError } = await sb.auth.getUser();
  if (userError || !user.user) return null;
  const { data, error } = await sb.rpc("is_current_user_admin");
  if (error || typeof data !== "boolean") return null;
  return data;
}
